// src/project/data/triggers/setRiderAvailability.js
import { buildActionUrl, RIDER_ENDPOINTS, getRiderId } from '../config/apiConfig'
import Storage from '@/shared/utils/storage'

import Events from '@/events/events'

export default {
  postUrl() {
    const riderId = getRiderId()
    // Nouveau endpoint V3 — POST avec corps vide, l'API bascule automatiquement
    return buildActionUrl(RIDER_ENDPOINTS.TOGGLE_STATUS(riderId))
  },
  format(payload) {
    // V3 : Le body doit être VIDE — l'API identifie le rider par l'URL et bascule le statut
    return {}
  },
  parse(raw = {}, payload) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Rider is now online", data: { id, status: "online", lastOnlineDate: "...", ... } }
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: null,
      }
    }

    const status = raw?.data?.status || (payload?.isAvailable ? 'online' : 'offline')

    // Sauvegarde du statut en local
    Storage.save('riderStatus', status)
    const userData = Storage.get('userData')
    if (userData) {
      userData.status = status
      Storage.save('userData', userData)
    }

    // Déclencher un événement global pour que la UI (comme RiderAvailabilityUpdater) puisse se rafraîchir
    try {
      Events.dispatch('rider_status_updated')
    } catch (e) {}

    if (typeof window !== 'undefined' && window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('rider_status_updated'))
    }

    return {
      statusCode: 200,
      message: raw?.message || 'Statut mis à jour avec succès',
      data: {
        saved: true,
        isAvailable: status === 'online',
        rider: raw?.data || null,
      },
    }
  },
}
